(function () {
  function initPlaceholder(input) {
    if (!input || input.dataset.placeholderInit === 'true') return;

    var words = (input.dataset.placeholderWords || '')
      .split(',')
      .map(function (w) {
        return w.trim();
      })
      .filter(Boolean);

    if (words.length === 0) return;

    input.dataset.placeholderInit = 'true';

    var basePlaceholder = input.getAttribute('placeholder') || '';
    var typingSpeed = parseInt(input.dataset.typingSpeed || '100', 10);
    var deletingSpeed = parseInt(input.dataset.deletingSpeed || '60', 10);
    var delayAfterWord = parseInt(input.dataset.delayAfterWord || '2000', 10);
    var delayAfterDelete = parseInt(input.dataset.delayAfterDelete || '400', 10);

    var wordIndex = 0;
    var charIndex = 0;
    var deleting = false;
    var timer = null;

    function schedule(fn, delay) {
      timer = setTimeout(fn, delay);
    }

    function tick() {
      if (input.value || document.activeElement === input) {
        input.setAttribute('placeholder', basePlaceholder);
        schedule(tick, 500);
        return;
      }

      var word = words[wordIndex];

      if (!deleting) {
        charIndex++;
        input.setAttribute('placeholder', word.slice(0, charIndex));
        if (charIndex >= word.length) {
          deleting = true;
          schedule(tick, delayAfterWord);
          return;
        }
        schedule(tick, typingSpeed);
      } else {
        charIndex--;
        input.setAttribute('placeholder', word.slice(0, Math.max(charIndex, 0)));
        if (charIndex <= 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
          schedule(tick, delayAfterDelete);
          return;
        }
        schedule(tick, deletingSpeed);
      }
    }

    tick();

    input.addEventListener(
      'blur',
      function () {
        if (!timer) tick();
      },
      { passive: true }
    );
  }

  function init() {
    document.querySelectorAll('input[data-placeholder-words]').forEach(initPlaceholder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
